import { MutableRefObject } from 'react'

import { FormHandles } from '@unform/core'
import { AxiosError } from 'axios'
import i18next from 'i18next'
import { ValidationError } from 'yup'

import { dispatchFeedbackToast } from '~/components/feedback'

export const requiredValidation = value =>
  value ? undefined : i18next.t('config:profile.generalData.requiredField')

export const emailValidation = (value: string) => {
  if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
    return 'Endereço de email inválido'
  }
  return undefined
}

export const passwordValidation = value => {
  if (value && !/^(?=.*[a-z])(?=.*[0-9])(?=.*[\W])(?=.{8,})/i.test(value)) {
    return 'Senha inválida'
  }
  return undefined
}

export const getValidationErrors = err => {
  const validationErrors = {}

  err.inner.forEach(error => {
    validationErrors[error.path] = error.message
  })

  return validationErrors
}

export const handleValidationsErrors = (
  error,
  formRef,
  showToast = true,
  logError = true
) => {
  if (error instanceof ValidationError) {
    const errors = getValidationErrors(error)

    formRef.current?.setErrors(errors)

    if (logError) console.error(errors?.formData || errors)

    if (!showToast) return

    return dispatchFeedbackToast({
      type: 'critical',
      message: 'Houve um erro ao validar os campos.'
    })
  }
}

export const getValidationErrorsAPI = (err: ValidationBffErrors[]) => {
  const validationErrors: { [key: string]: string } = {}

  err.forEach(error => {
    validationErrors[error.property] = error.errors
      .map(e => e.message)
      .join(', ')
  })

  return validationErrors
}

export const isValidationError = (
  error: AxiosError<APIErrorRawResponse> | Error
): error is AxiosError<ValidationBffError> => {
  return (
    'response' in error &&
    error.response !== undefined &&
    'data' in error.response &&
    'error_type' in error.response.data &&
    error.response.data.error_type === 'VALIDATION_ERRORS'
  )
}

/**
 * Helper para exibir os erros de validação da API direto no formulário
 * @param error
 * @param formRef
 */
export const handleValidationsErrorsAPI = (
  error: AxiosError<APIErrorRawResponse> | Error,
  formRef: MutableRefObject<FormHandles>
) => {
  if (isValidationError(error)) {
    const response = error.response!.data as ValidationBffError
    const errors = getValidationErrorsAPI(response.validations)

    console.error(errors)

    formRef.current?.setErrors(errors)
  }
}
